import { render, staticRenderFns } from "./btn-direction-new.vue?vue&type=template&id=7137e792&scoped=true"
import script from "./btn-direction-new.vue?vue&type=script&lang=ts"
export * from "./btn-direction-new.vue?vue&type=script&lang=ts"
import style0 from "./btn-direction-new.vue?vue&type=style&index=0&id=7137e792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7137e792",
  null
  
)

export default component.exports